<!-- some class definations
vs-up = for screen larger than very small size
sm-up/down = for screen larger/smaller than small size
md-up/down = for screen larger/smaller than midium size
lg-up/down = for screen larger/smaller than large size -->
<div class="invitation" :class="interestCheckClass">

    <linear-progress :active="loading"></linear-progress>

    <div class="m-panel" v-if="userInfo && interestCheckInvite">
        <div class="welcome-page__block1">
            <div>
                <div class="welcome-page__text">
                    <p class="welcome-page__title">Welcome, {{ userInfo.firstName }}!</p>
                    <p class="welcome-page__welcome-message">
                        Welcome to Monjin, You are going to submit an interest check <br/> for <span class="welcome-page__company-name">{{ userInfo.tenantName }}</span>
                    </p>
                </div>
                <div class="welcome-page__logo-images">
                    <img v-if="userInfo.tenantLogo" :src="userInfo.tenantLogo">
                    <img :src="'/static/monjin-logo-orange.png'" alt="Monjin"/>
                </div>
            </div>
        </div>

        <div class="welcome-page__block3">
            <div class="welcome-page__wrapper">
                <div>
                    <mom-button variant="raised" @click="changeRoute">{{ interestCheckInvite ? 'Proceed' :'Continue on Web' }}</mom-button>
                </div>
            </div>
        </div>
    </div>

    <div class="welcome-page m-panel" v-if="userInfo && !interestCheckInvite">


        <div class="welcome-page__block1">
            <div>
                <div class="welcome-page__text">
                    <p class="welcome-page__title">Welcome, {{ userInfo.firstName }}!</p>
                    <p class="welcome-page__welcome-message">
                        Welcome to Monjin, You are going to give an interview <br/> for <span class="welcome-page__company-name">{{ userInfo.tenantName }}</span>
                    </p>
                </div>
                <div class="welcome-page__logo-images">
                    <img v-if="userInfo.tenantLogo" :src="userInfo.tenantLogo" :class="{ 'welcome-page__logo-images--invert' : userInfo.monochrome }">
                    <img :src="'/static/monjin-logo-orange.png'" alt="Monjin"/>
                </div>
            </div>
        </div>

        <div class="welcome-page__block2" v-if="canContinueOnMobile">
            <div class="welcome-page__wrapper">
                <p class="welcome-page__appstore-message">
                    Use the code to take interview on the app
                </p>
                <p class="welcome-page__code">Code - {{ inviteCode }}</p>
                <div class="welcome-page__actions">
                    <div class="welcome-page__actions-link">
                        <h4 class="welcome-page__appstore">App Available On</h4>
                        <div class="welcome-page__appstore-images">
                            <a href="https://play.google.com/store/apps/details?id=com.app.monjin" target="_blank"><img src="../../../assets/play-store.png" alt="googlePlayStore"/></a>
                            <a href="https://itunes.apple.com/in/app/monjin/id1412642049?mt=8" target="_blank"><img src="../../../assets/apple-store.png" alt="applePlayStore"/></a>
                        </div>
                    </div>
                    <div class="welcome-page__actions-scan">
                        <h4 class="welcome-page__appstore">Scan to download the app</h4>
                        <div class="welcome-page__appstore-qr">
                            <img src="../../../assets/QR_code.png" alt="QRCode">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="welcome-page__block2" v-else>
            <div class="welcome-page__wrapper">
                <p>
                    This video activity contains elements which are currently not supported on our mobile app.
                </p>
                <div>
                    <mom-button variant="raised" @click="changeRoute">Continue on Web</mom-button>
                </div>
            </div>
        </div>

        <div class="welcome-page__block3">
            <div class="welcome-page__wrapper">
                <p class="welcome-page__message">
                    Take a video interview now and showcase it to potential employers!
                </p>
                <div>
                    <mom-button variant="raised" @click="changeRoute">Continue on Web</mom-button>
                </div>
            </div>
        </div>

        <div class="welcome-page__block4 sm-up">
            <div class="welcome-page__wrapper">
                <p class="welcome-page__interview-message">
                    Take the interview on mobile
                </p>
                <div class="welcome-page__company">If you intend to take the interview on an ipad or iphone<br/>Please download our app.</div>
                <div class="welcome-page__app-screen">
                    <img src="../../../assets/app-screens.png" alt="Monjin App"/>
                </div>
            </div>
        </div>
    </div>
    <mom-dialog ref="dialog" :escape="false">
        <div slot="header">Scheduled Maintenance!</div>
        <div class="">
            <h3>{{ claimError }}</h3>
        </div>
        <mom-button slot="footer" data-mdc-dialog-action="cancel" class="m-button--smoke">Ok</mom-button>
    </mom-dialog>
    <div class="invitation__error m-panel" v-if="errorMessage">
        <h2 v-html="errorMessage"></h2>
        <p v-if="unknownError">
            Please try after some time.
            Contact administrator if the problem persists.
        </p>
    </div>
</div>